import { useCallback } from "react";

import { useDefaultScaleRange } from "../../../../hooks/style/useDefaultScaleRange";
import { Preview } from "../../../../hooks/useMetaPreview";
import { ResourceInfoDc } from "../../../../modules/Catalog/types";

export const useResourceUpdate = (update, updatePreview) => {
  const defaultScaleRange = useDefaultScaleRange();

  return useCallback(
    (resource: ResourceInfoDc, preview?: Preview) =>
      update({ input: { configuration: resource, defaultScaleRange } }).then(() => {
        if (!preview) return;

        const isDelete = preview.resourcePreview === undefined && !preview.file && !preview.src;
        const isUpdate = preview.file && preview.src;

        if (isDelete || isUpdate) {
          return updatePreview(resource.name, preview.file);
        }
      }),
    [defaultScaleRange, update, updatePreview],
  );
};
